import dayjs from 'dayjs';

function _renderBackButton(options) {
	return `
		<button class="post post--button" post-id="1597740452353352185" post-theme="default" render-type="PostButton" element-type="post" data-url="${options.back.command}" tabindex="0">
			<div class="element element--text" render-type="ElementText" element-id="1597740452353352187" element-type="text">
				${options.back.label}
			</div>
		</button>
	`;
}

function _getMediaObjectHtml(mediaObjectCover, imageSize) {
	return `<figure class="element element--image" element-translation="found" media-id="unknown"
			media-active="false" media-ratio="100" alt="alternative text" image-mode="cover" image-position="center"
			render-type="ElementImage" media-type="image" id="1553024173047466" element-type="images"
			style="transform: translate3d(0px, 0px, 0px);"><div
						class="element__fullimage"
						loaded="false"
						style="background-image:url(${mediaObjectCover.sourceUrl}/${imageSize});"
					></div></figure>`;
}

function _renderHeader(options) {
	const { mediaObjectCover, title, description, date, startTime, imageSize } = options;
	return `<header
			class="post post--header"
			post-theme="default"
			post-active="false"
			elements-hidden="element__caption__headline:true,element__caption__text:true,element--image:true"
			render-type="PostHeader"
			id="15477430599479462"
			element-type="post"
			${date ? `data-date=${date}` : ''}
			${startTime ? `data-date=${startTime}` : ''}
		}
		>
			<div class="post__container post__container--image">${
				mediaObjectCover ? _getMediaObjectHtml(mediaObjectCover, imageSize) : ''
			}</div>
			<div class="post__container post__container--text post__wrapper--text">
				<h1
					class="element element--headline element--headline--big"
					element-translation="found"
					render-type="ElementHeadlineBig"
					id="15477430599479463"
					element-type="headline"
				>
					${title}
				</h1>
				<p
					class="element element--text"
					element-translation="found"
					render-type="ElementText"
					id="15477430599489474"
					element-type="text"
				>${description}</p>
				<div class="post__dateTime">
					<div class="post__dayname">${date ? dayjs(date).format('dddd') : ''}</div>
					<div class="post__date">${date ? dayjs(date).format('DD.MM.YYYY') : ''}</div>
					<div class="post__time">${date ? dayjs(date).format('HH.mm') : ''}</div>
				</div>
			</div>
		</header>`;
}

/**
 * temporary render function for calendarEvents and
 * Terms, later should be using renderTemplates as builder
 *
 * @param { mediaObjectCover, title, description, content, date, startTime } values
 */
export function renderHeaderAndText(options) {
	const { hasHeader, content, pageTheme } = Object.assign(
		{
			hasHeader: true,
			title: '',
			description: '',
			content: '',
		},
		options
	);
	return `
	<div class="wrapper wrapper--page" page-theme="${
		pageTheme ? pageTheme : 'default'
	}" render-type="WrapperPage" element-type="page">
	<div
		class="wrapper wrapper--board"
		max-drop="infinite"
		id="*$id*"
		render-type="WrapperBoard"
		element-type="board">
	${hasHeader ? _renderHeader(options) : ''}
		<div
			class="post post--text"
			post-theme="default"
			post-active="false"
			render-type="PostText"
			id="15477431148108099"
			element-type="post">
			<div
				class="element element--text"
				element-translation="found"
				render-type="ElementText"
				id="154774311481080910"
				element-type="text"
				>${content}</div
			>
		</div>
		${options.back ? _renderBackButton(options) : ''}
	</div>
</div>
	`;
}

export function renderExternal(_options) {
	const options = Object.assign(
		{
			url: '',
			pageTheme: 'single-post',
		},
		_options
	);
	return `
<div class="wrapper wrapper--page" page-theme="${options.pageTheme}" render-type="WrapperPage" element-type="page">
	<div
		class="wrapper wrapper--board"
		max-drop="infinite"
		render-type="WrapperBoard"
		element-type="board">
		<external-post
			class="post post--external"
			post-theme="default"
			post-active="false"
			render-type="PostExternal"
			element-type="post">
			<iframe src="${options.url}" class="post post--external" frameBorder="0">Browser not compatible.</iframe>

		</external-post>
	</div>
</div>
	`;
}
